export default class QuickResponse {
    constructor(payload) {
      this.text = payload.text || '';
      this.buttonId = payload.buttonId || null;
      this.open = payload.open || ''; 
      this.type = payload.type || '';
      this.url = payload.url || '';
    }
  }
  